<div mat-dialog-content role="dialog" aria-modal="true" aria-labelledby="tf-select-cert-reset-title" aria-describedby="tf-select-cert-reset-desc">
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <i class="fas fa-key" aria-hidden="true"></i>
    </div>
    <h3 id="tf-select-cert-reset-title">Restablecer PIN – Seleccione su certificado</h3>
    <p id="tf-select-cert-reset-desc" class="sr-only">Elija el certificado de su token para continuar con el restablecimiento del PIN</p>
  </div>

  <div class="tf-cert-content">
    <p class="label-document">Seleccione el certificado de su token para continuar</p>
    <div class="certificate-list">
      <div
        class="certificate-item"
        *ngFor="let cert of data.certificates"
        (click)="selectCertificate(cert)"
        [class.selected]="selectedCertificate === cert"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Certificado: ' + displayName(cert)"
        [attr.aria-pressed]="selectedCertificate === cert"
        (keydown.enter)="selectCertificate(cert)"
        (keydown.space)="selectCertificate(cert); $event.preventDefault()">
        <img
          *ngIf="selectedCertificate !== cert"
          src="assets/icons/certificate-icon-unselected.svg"
          alt=""
          class="certificate-logo" />
        <img
          *ngIf="selectedCertificate === cert"
          src="assets/icons/certificate-icon-selected.svg"
          alt=""
          class="certificate-logo" />
        <div class="certificate-info">
          <div class="certificate-title-row">
            <p class="certificate-title">{{ displayName(cert) }}</p>
            <span *ngIf="getCertificateType(cert)"
                  class="certificate-badge"
                  [ngClass]="getCertificateType(cert)?.cssClass">
              {{ getCertificateType(cert)?.label }}
            </span>
          </div>
          <p class="cert-issuer" *ngIf="cert.issuerDN">
            <i class="fas fa-building" aria-hidden="true"></i> {{ extractIssuerName(cert.issuerDN) }}
          </p>
          <div class="certificate-details">
            <span class="cert-detail" *ngIf="cert.serialNumber">
              <i class="fas fa-hashtag" aria-hidden="true"></i> {{ formatSerial(cert.serialNumber) }}
            </span>
            <span class="cert-detail" *ngIf="cert.keyAlgorithm">
              <i class="fas fa-key" aria-hidden="true"></i> {{ cert.keyAlgorithm }}
            </span>
          </div>
          <div class="certificate-dates">
            <span class="cert-detail" *ngIf="cert.notBefore">
              <i class="fas fa-calendar-plus" aria-hidden="true"></i> Desde: {{ formatDate(cert.notBefore) }}
            </span>
            <span class="cert-detail" *ngIf="cert.notAfter">
              <i class="fas fa-calendar-times" aria-hidden="true"></i> Hasta: {{ formatDate(cert.notAfter) }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="btn btn-secondary" (click)="closeDialog()" aria-label="Cancelar">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="confirmSelection()"
        [disabled]="!selectedCertificate"
        [attr.aria-label]="selectedCertificate ? 'Continuar con certificado seleccionado' : 'Seleccione un certificado'"
        [attr.aria-disabled]="!selectedCertificate">
        Continuar
      </button>
    </div>
  </div>
</div>
